






































import CommonBase from "../CommonBase";
import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {TerminalLocation, UserSiteReportRow} from "../../modules/models";

@Component
export default class LastRegsCard extends CommonBase {
    @Inject()
    api!: Api;

    locations: TerminalLocation[] = [];
    loading = false;

    private pShowLocation: TerminalLocation | null = null;
    get showLocation(): TerminalLocation | null {
        return this.pShowLocation;
    }
    set showLocation(l: TerminalLocation | null) {
        this.pShowLocation = l;
        // Trigger load of report data for the location
        if(l != null) {
            this.loadReport();
        } else {
            this.report = [];
        }
    }

    headers = [
        {text: "Inn", value: "inTime", align: "left"},
        {text: "Ut", value: "outTime", align: "left"},
    ];

    report: UserSiteReportRow[] = [];

    async loadLocations() {
        try {
            this.loading = true;
            this.locations = await this.api.fetchUserTermlocs();
            if(this.locations.length > 0) {
                this.showLocation = this.locations[0];
            }
        } catch (e) {
            this.emitError(e);
        } finally {
            this.loading = false;
        }
    }

    async loadReport() {
        if(this.showLocation != null) {
            try {
                this.loading = true;
                this.report = await this.api.fetchUserSiteReport(this.showLocation.id)
            } catch (e) {
                this.emitError(e);
            } finally {
                this.loading = false;
            }
        } else {
            this.report = [];
        }
    }

    created() {
        this.loadLocations();
    }
}
